export enum TemplateStatus {
  ACTIVE = 'ACTIVE',
  IN_ACTIVE = 'IN_ACTIVE',
}

export class Template {
  belongsToAll: boolean;
  belongsToReccoList: string;
  content: string;
  createdAt: Date;
  id: string;
  status: TemplateStatus;
  type: 'TEXT' | 'IMAGE';
  updatedAt: Date;

  constructor(json: any) {
    this.belongsToAll = json.belongsToAll;
    this.belongsToReccoList = json.belongsToReccoList;
    this.content = json.content;
    this.createdAt = json.createdAt && new Date(json.createdAt);
    this.id = json.id || json._id;
    this.status = json.status;
    this.type = json.type;
    this.updatedAt = json.updatedAt && new Date(json.updatedAt);
  }
}
